<script>
  import { PKClient } from "../services/PKClient.js";
  import { GQLNow } from "gql-now";
  import { onMount } from "svelte";
  import {
    App,
    f7,
    f7ready,
    Page,
    CardFooter,
    CardContent,
    CardHeader,
    PageContent,
    Card,
    Navbar,
    NavLeft,
    NavTitle,
    NavTitleLarge,
    NavRight,
    Link,
    Toolbar,
    Block,
    BlockTitle,
    List,
    ListItem,
    ListInput,
    Row,
    Col,
    Button,
    LoginScreenTitle,
    ListButton,
    BlockFooter,
  } from "framework7-svelte";

  import { ORG_ID, MEMBER_SERVICES_URL, setAdminToken } from "../js/auth";

  export let f7route;
  export let f7router;

  let mobile = "";
  let otp = "";
  let session_key = "";

  onMount(() => {
    f7ready(async () => {
      mobile = f7route.query.mobile;
      session_key = localStorage.getItem("session-key");
      if (!mobile || !session_key) {
        f7router.navigate("/");
      }
    });
  });

  async function signIn() {
    try {
      let response = await verify_admin_session_otp();
      console.log(response);
      if (response && response.status === "true" && response.token) {
        setAdminToken(response.token);
        f7router.navigate(`/admin-home/`);
      } else {
        f7.dialog.alert("Invalid credentials");
      }
    } catch (err) {
      console.log(err);
      let errMsg = "Invalid credentials";
      if (err && err.data && err.data.errors && err.data.errors.length > 0) {
        errMsg = err.data.errors[0].message || "Invalid credentials";
      } else if (err && err.message) {
        errMsg = err.message;
      }
      f7.dialog.alert(errMsg);
    }
  }

  const verify_admin_session_otp = async () => {
    let cleanOtp = otp ? otp.toString().trim() : "";
    if (cleanOtp) {
      let obj = new GQLNow(MEMBER_SERVICES_URL, {
        "x-trdr-org": ORG_ID,
      });
      try {
        f7.preloader.show();
        const response = await obj.mutation(
          "verify_admin_session_otp",
          {
            mobile: mobile ? mobile.toString().trim() : "",
            otp_secret: cleanOtp,
            session_id: session_key,
          },
          "status token"
        );
        f7.preloader.hide();
        return response.data.verify_admin_session_otp;
      } catch (err) {
        f7.preloader.hide();
        console.log(err);
        throw err;
      }
    } else {
      f7.dialog.alert("Please enter OTP");
    }
  };
</script>

<Page name="merchant-login" noToolbar noNavbar noSwipeback loginScreen>
  <LoginScreenTitle>Admin Login</LoginScreenTitle>
  <List form>
    <!-- <ListInput
      label="OTP"
      type="tel"
      placeholder="Your password"
      value={otp}
      onInput={(e) => (otp = e.target.value)}
    /> -->
    <li class="item-content item-input">
      <div class="item-inner">
        <div class="item-title item-label">OTP</div>
          <div id="divOuter">
	          <div id="divInner">
		          <input id="partitioned" on:input={(e) => (otp = e.target.value)} type="text" maxlength="4" />
	          </div>
          </div>
      </div>
    </li>
  </List>
  <List>
    <Button fill onClick={signIn}>Sign In</Button>
   
  </List>
  <!-- <BlockFooter>
    Please login with your Admin Login credentials.
    <br />
    Login to start managing customers,merchants kits , topups, spend reports and
    much more.
  </BlockFooter> -->
</Page>

<style>
  #partitioned {
  padding-left: 15px;
  letter-spacing: 42px;
  border: 0;
  background-image: linear-gradient(to left, black 70%, rgba(255, 255, 255, 0) 0%);
  background-position: bottom;
  background-size: 50px 1px;
  background-repeat: repeat-x;
  background-position-x: 35px;
  width: 220px;
  min-width: 220px;
}

#divInner{
  left: 0;
  position: sticky;
}

#divOuter{
  width: 190px; 
  overflow: hidden;
}
</style>
